import {keyCodes} from '../../../utility/js/utils';
export default class LoginForm {
    selectors = {
        loginForm: '.login-form',
        messageError: '#login-error-message',
        inputGroupErrror: '.input-group .error',
        membership: '.membership-access-code .infoBox',
        userNameInput: '#username',
        loginInitiate: '[data-acdl-event=login-initiate],[data-acdl-event=registration-initiated]',
        individualUser: '.loginBar .individualUser',
        individualAccordion: '.accordion-tabbed__control',
    };

    elements = {
        loginForm: null,
        messageError: null,
        inputGroupErrror: null,
        membership: null,
        userNameInput: null,
        loginInitiate: null,
        individualUser: null,
        individualAccordion: null,
    };

    constructor() {
        this.setElements();
        this.checkErrors();
        this.eventListeners();
        this.loginSuccess();
        this.handleDisplayPassword();
    }

    setElements() {
        this.elements.membership = document.querySelector(this.selectors.membership);
        this.elements.messageError = document.querySelector(this.selectors.messageError);
        this.elements.loginInitiate = UX.utils.convertToArray(document.querySelectorAll(this.selectors.loginInitiate));
        this.elements.individualUser = document.querySelector(this.selectors.individualUser);
        this.elements.individualAccordion = document.querySelector(this.selectors.individualAccordion);

        if (this.elements.messageError) {
            this.elements.individualAccordion?.click();
            this.elements.loginForm = this.elements.messageError.closest(this.selectors.loginForm);
            this.elements.inputGroupErrror = this.elements.loginForm?.querySelector(this.selectors.inputGroupErrror);
            this.elements.userNameInput = this.elements.loginForm?.querySelector(this.selectors.userNameInput);
        }
    }

    eventListeners() {
        this.elements.loginInitiate?.forEach(button => {
            button.addEventListener('click', e => {
                localStorage.setItem('logInSubmit', true);
            });
        });
    }

    checkErrors() {
        if (this.elements.messageError && this.elements.inputGroupErrror && this.elements.membership) {
            this.elements.messageError.classList.add('hidden');
        } else if (this.elements.messageError) {
            const message = this.elements.messageError?.textContent.replaceAll('-', '').trim();
            window.adobeDataLayer && UX.adobeDigitalData.loginEvents.error(message);
            this.elements.userNameInput?.focus();
        }
    }

    loginSuccess() {
        if (localStorage.getItem('logInSubmit') && this.elements.individualUser) {
            window.adobeDataLayer && UX.adobeDigitalData.loginEvents.success();
            localStorage.removeItem('logInSubmit');
        } else if (localStorage.getItem('logInSubmit')) {
            localStorage.removeItem('logInSubmit');
        }
    }

    handleDisplayPassword() {
        const {RETURN, SPACE} = keyCodes;
        const showPasswordBtn = document.querySelector('.password-eye-icon');
        showPasswordBtn?.addEventListener('click', e => {
            showPasswordBtn?.classList.contains('icon-eye-blocked')
                ? e.target.setAttribute('aria-pressed', 'true')
                : e.target.setAttribute('aria-pressed', 'false');
        });
        showPasswordBtn?.addEventListener('keydown', e => {
            if (e.keyCode === RETURN || e.keyCode === SPACE) {
                e.preventDefault();
                e.target.click();
            }
        });
    }
}
